import { COLORS } from '../utils/colors';
import { siteContent } from '../content';
import { Card, Section } from './Card';

export const NonProfit = ({ isVisible }) => (
  <Section
    id="nonprofit"
    alt
    isVisible={isVisible}
    title={<>Non Profit <span style={{ color: COLORS.cantaloupe }}>Technology Leadership</span></>}
    subtitle={siteContent.nonprofit.subtitle}
  >
    <div className="grid md:grid-cols-2 gap-8 mb-12">
      {siteContent.nonprofit.services.map((service) => (
        <Card key={service.title}>
          <div className="flex items-start space-x-4">
            <div className="text-3xl">{service.icon}</div>
            <div>
              <h3 className="text-xl font-bold mb-3" style={{ color: COLORS.navy }}>{service.title}</h3>
              <p style={{ color: COLORS.slate }}>{service.description}</p>
            </div>
          </div>
        </Card>
      ))}
    </div>

    <Card>
      <div className="grid md:grid-cols-2 gap-8 items-center">
        <div>
          <h3 className="text-2xl font-bold mb-4" style={{ color: COLORS.navy }}>
            Why Non Profits Choose <span style={{ color: COLORS.cantaloupe }}>rockmelon</span>
          </h3>
          <div className="space-y-3">
            {siteContent.nonprofit.benefits.map((benefit, index) => (
              <div key={index} className="flex items-center">
                <span className="mr-3 text-lg" style={{ color: COLORS.teal }}>✓</span>
                <span style={{ color: COLORS.slate }}>{benefit}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="text-center">
          <div className="rounded-2xl p-8" style={{ background: 'linear-gradient(to bottom right, rgba(255,130,67,0.1), rgba(45,212,191,0.1))', border: '1px solid #E2E8F0' }}>
            <div className="text-4xl mb-4">💝</div>
            <div className="text-3xl font-bold mb-2" style={{ color: COLORS.cantaloupe }}>{siteContent.nonprofit.metrics.costReduction}</div>
            <div className="text-sm mb-4" style={{ color: COLORS.slate }}>{siteContent.nonprofit.metrics.costReductionLabel}</div>
            <div className="text-3xl font-bold mb-2" style={{ color: COLORS.teal }}>{siteContent.nonprofit.metrics.compliance}</div>
            <div className="text-sm" style={{ color: COLORS.slate }}>{siteContent.nonprofit.metrics.complianceLabel}</div>
          </div>
        </div>
      </div>
    </Card>
  </Section>
);
